import { extractAxiosErrorType } from '@heidi/api/errors';
import { isAxiosError } from 'axios';

/** Machine `detail.type` on the agent send/run 402 refuse. */
export const CREDIT_ALLOWANCE_EXHAUSTED_TYPE = 'CreditAllowanceExhausted';

/** True for the 402 + `CreditAllowanceExhausted` refuse from agent send/run. */
export function isCreditAllowanceExhausted(error: unknown): boolean {
  return (
    isAxiosError(error) &&
    error.response?.status === 402 &&
    extractAxiosErrorType(error) === CREDIT_ALLOWANCE_EXHAUSTED_TYPE
  );
}
